import { CSSVariablesResolver } from "@mantine/core";

/* Save time on styling with our ready-to-use themes for Mantine components. Just copy, paste, and watch your app come to life.

https://mantinehub.com/


mantine
Shadcn
radixUI */

export const CssVariableResolver: CSSVariablesResolver = () => ({
  variables: {
    //  variables that do not depend on color scheme
  },
  light: {
    // variables for light color scheme only
  },
  dark: {
    // variables for dark color scheme only
  },
});
